import { render } from "./modalsContainer.vue?vue&type=template&id=dfc0550a&scoped=true&ts=true"
import script from "./modalsContainer.vue?vue&type=script&lang=ts"
export * from "./modalsContainer.vue?vue&type=script&lang=ts"

import "./modalsContainer.vue?vue&type=style&index=0&id=dfc0550a&scoped=true&lang=css"
import "./modalsContainer.vue?vue&type=style&index=1&id=dfc0550a&lang=css"

import exportComponent from "C:\\projects\\Auraclub\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfc0550a"]])

export default __exports__